import { setGoodieGiveawaySelectedProducts, getGoodieGiveawaySelectedProducts } from 'swag-client-common/utils/local-storage.util';
import { PREFIX as GLOBAL_PREFIX } from '../goodie-giveaway.actions';
import { goodieGiveawaySelectedProductsListSelector } from '../selectors/goodie-giveaway-selection.selectors';
const PREFIX = `${GLOBAL_PREFIX}PRODUCTS_`;
export const TOGGLE_PRODUCT = `${PREFIX}TOGGLE_PRODUCT`;
export const toggleProduct = (product, link) => dispatch => {
  dispatch({
    type: TOGGLE_PRODUCT,
    payload: {
      product
    }
  });
  dispatch(updateLocalSelection(link));
};
export const CHANGE_PRODUCT_QUANTITY = `${PREFIX}CHANGE_PRODUCT_QUANTITY`;
export const changeQuantity = (productId, quantity, link) => dispatch => {
  dispatch({
    type: CHANGE_PRODUCT_QUANTITY,
    payload: {
      productId,
      quantity
    }
  });
  dispatch(updateLocalSelection(link));
};
export const SET_LIST_PRODUCTS = `${PREFIX}SET_LIST_PRODUCTS`;
export const setSelectedGoodieProductsList = link => dispatch => {
  const list = getGoodieGiveawaySelectedProducts(link);
  dispatch({
    type: SET_LIST_PRODUCTS,
    payload: {
      list
    }
  });
};
export const updateLocalSelection = link => (dispatch, getState) => {
  const list = goodieGiveawaySelectedProductsListSelector(getState());
  setGoodieGiveawaySelectedProducts(list, link);
};